import {Injectable} from '@angular/core';
import {FunktionswertComponent} from '../../../cockpit-m2/funktionswert/funktionswert.component';

import {CockpitCard} from 'shared/dtos/cockpit-card';
import {DataService} from 'shared/services/data.service';
import {MessageService} from 'shared/services/message.service';
import {ChartDialogKennzahlenMethodikComponent} from '../../../cockpit-m1/kennzahlen-methodik/kennzahlen-methodik.component';
import {ChartDialogPersonenStellenbezogeneMerkmaleComponent} from '../../../cockpit-m1/personen-stellenbezogene-merkmale/personen-stellenbezogene-merkmale.component';
import {ChartDialogPersonenStellenbezogeneMerkmaleM2Component} from '../../../cockpit-m2/chart-dialog-personen-stellenbezogene-merkmale-m2/chart-dialog-personen-stellenbezogene-merkmale-m2.component';
import {ChartDialogKennzahlenMethodikM2Component} from '../../../cockpit-m2/kennzahlen-methodik-m2/kennzahlen-methodik-m2.component';
import {ChartDialogEinfuehrungUndDownloadComponent} from '../../contents/chart-dialog-einfuehrung-und-download/chart-dialog-einfuehrung-und-download.component';
import {ChartDialogFunktionenstatistikenLoehneComponent} from '../../contents/chart-dialog-funktionenstatistiken-loehne/chart-dialog-funktionenstatistiken-loehne.component';
import {ChartDialogFunktionenstatistikenPersonenComponent} from '../../contents/chart-dialog-funktionenstatistiken-personen/chart-dialog-funktionenstatistiken-personen.component';
import {ChartDialogGesamtverdienstLohnbestandteileComponent} from '../../contents/gesamtverdienst-lohnbestandteile/chart-dialog-gesamtverdienst-lohnbestandteile.component';
import {ChartDialogLohnverteilungComponent} from '../../contents/lohnverteilung/chart-dialog-lohnverteilung.component';
import {ChartDialogPersonalaufwandComponent} from '../../contents/personalaufwand/personalaufwand.component';
import {ChartDialogPersonalbestandComponent} from '../../contents/personalbestand/cart-dialog-personalbestand.component';
import {CockpitBaseService} from './cockpit-base.service';

@Injectable({providedIn: 'root'})
export class CockpitStandardService extends CockpitBaseService {
  protected cardsData: CockpitCard[] = [
    {
      component: ChartDialogEinfuehrungUndDownloadComponent,
      name: 'EinfuehrungUndDownload',
      title: 'm2.sprint6.cockpit.card.chart.einfuehrungUndDownload.title',
      isSelected: true,
      content: [],
      position: 1
    },
    {
      component: ChartDialogPersonalbestandComponent,
      name: 'Personalbestand',
      title: 'i18n.cockpit.card.Personalbestand.title',
      isSelected: false,
      content: [
        'm1-m2.sprint8.cockpit.card.Personalbestand.content1',
        'm1-m2.sprint8.cockpit.card.Personalbestand.content3'
      ],
      position: 2
    },
    {
      component: ChartDialogGesamtverdienstLohnbestandteileComponent,
      name: 'GesamtverdienstUndLohnbestandteile',
      title: 'i18n.cockpit.card.GesamtverdienstLohn.title',
      isSelected: false,
      content: [
        'i18n.cockpit.card.GesamtverdienstLohn.content1',
        'i18n.cockpit.card.GesamtverdienstLohn.content2',
        'i18n.cockpit.card.GesamtverdienstLohn.content3',
        'i18n.cockpit.card.GesamtverdienstLohn.content4'
      ],
      position: 3
    },
    {
      component: ChartDialogLohnverteilungComponent,
      name: 'Lohnverteilung',
      title: 'i18n.cockpit.card.Lohnteilung.title',
      isSelected: false,
      content: ['i18n.cockpit.card.Lohnteilung.content1'],
      position: 4
    },
    {
      component: ChartDialogFunktionenstatistikenPersonenComponent,
      name: 'FunktionenstatistikenPersonenM1',
      title: 'm2.sprint9.cockpit.card.funktionenstatistiken.personen.title',
      isSelected: false,
      content: [
        'm1.sprint10.cockpit.card.funktionenstatistiken.content.1',
        'm2.sprint9.cockpit.card.funktionenstatistiken.personen.content.2',
        'm2.sprint9.cockpit.card.funktionenstatistiken.personen.content.3'
      ],
      position: 5,
      module: 1
    },
    {
      component: ChartDialogFunktionenstatistikenLoehneComponent,
      name: 'FunktionenstatistikenLoehneM1',
      title: 'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.title',
      isSelected: false,
      content: [
        'm1.sprint10.cockpit.card.funktionenstatistiken.content.1',
        'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.content.2'
      ],
      position: 6,
      module: 1
    },
    {
      component: ChartDialogPersonenStellenbezogeneMerkmaleComponent,
      name: 'PersonenUndStellenbezogeneMerkmale',
      title:
        'm1-m2.sprint10.cockpit.card.PersonalStellenbezogeneMerkmale.title',
      isSelected: false,
      content: ['i18n.cockpit.card.PersonalStellenbezogeneMerkmale.content1'],
      position: 7,
      module: 1
    },
    {
      component: ChartDialogPersonalaufwandComponent,
      name: 'Personalaufwand',
      title: 'i18n.cockpit.card.Personalaufwand.title',
      isSelected: false,
      content: ['i18n.cockpit.card.Personalaufwand.content1'],
      position: 9
    },
    {
      component: ChartDialogKennzahlenMethodikComponent,
      name: 'KennzahlenZurMethodik',
      title: 'i18n.cockpit.card.KennzahlenZurMethodik.title',
      isSelected: false,
      content: [
        'i18n.cockpit.card.KennzahlenZurMethodik.content1',
        'm1.sprint10.cockpit.card.KennzahlenZurMethodik.content2',
        'm1.sprint10.cockpit.card.KennzahlenZurMethodik.content3',
        'm1.sprint10.cockpit.card.KennzahlenZurMethodik.content4'
      ],
      position: 10,
      module: 1
    },
    {
      component: FunktionswertComponent,
      name: 'Funktionswert',
      title: 'm2.sprint3.cockpit.card.funktionswert.title',
      isSelected: false,
      content: [
        'm2.sprint3.cockpit.card.funktionswert.content.1',
        'm2.cockpit.card.funktionswert.content.2'
      ],
      position: 5,
      module: 2
    },
    {
      component: ChartDialogFunktionenstatistikenPersonenComponent,
      name: 'FunktionenstatistikenPersonen',
      title: 'm2.sprint9.cockpit.card.funktionenstatistiken.personen.title',
      isSelected: false,
      content: [
        'm2.sprint9.cockpit.card.funktionenstatistiken.personen.content.1',
        'm2.sprint9.cockpit.card.funktionenstatistiken.personen.content.2',
        'm2.sprint9.cockpit.card.funktionenstatistiken.personen.content.3'
      ],
      position: 6,
      module: 2
    },
    {
      component: ChartDialogFunktionenstatistikenLoehneComponent,
      name: 'FunktionenstatistikenLoehne',
      title: 'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.title',
      isSelected: false,
      content: [
        'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.content.1',
        'm2.sprint9.cockpit.card.funktionenstatistiken.loehne.content.2'
      ],
      position: 6,
      module: 2
    },
    {
      component: ChartDialogPersonenStellenbezogeneMerkmaleM2Component,
      name: 'PersonenUndStellenbezogeneMerkmale',
      title:
        'm1-m2.sprint10.cockpit.card.PersonalStellenbezogeneMerkmale.title',
      isSelected: false,
      content: [
        'm2.sprint3.cockpit.card.PersonalStellenbezogeneMerkmale.content.1'
      ],
      position: 7,
      module: 2
    },
    {
      component: ChartDialogKennzahlenMethodikM2Component,
      name: 'KennzahlenZurMethodikM2',
      title: 'i18n.cockpit.card.KennzahlenZurMethodik.title',
      isSelected: false,
      content: [
        'm2.sprint2.cockpit.card.kennzahlenMethodik.content.1',
        'm2.sprint2.cockpit.card.kennzahlenMethodik.content.2',
        'm2.sprint2.cockpit.card.kennzahlenMethodik.content.3'
      ],
      position: 10,
      module: 2
    }
  ];

  constructor(
    protected readonly _dataService: DataService,
    protected readonly _messageServices: MessageService
  ) {
    super(_dataService, _messageServices);
  }
}
